import React, { useState } from 'react';
import type { MutableRefObject } from 'react';

import FormulaDropdown from './FormulaDropdown';
import type { FormulaDropdownRef } from './FormulaDropdown';
import DatePickerContainer from './cellTypes/DatePickerContainer';

import type { ImMNElement } from '../../../common/elements/elementModelTypes';
import { MNHotInstance } from './tableHotInstanceTypes';

type TablePopupsProps = {
    element: ImMNElement;
    gridSize: number;
    isCurrentlyEditingTableCell: boolean;
    dropdownRef: MutableRefObject<FormulaDropdownRef | null>;
    locale: string;
    hotTableInstanceRef: MutableRefObject<MNHotInstance | null>;
};

const TablePopups: React.FC<TablePopupsProps> = ({
    element,
    gridSize,
    isCurrentlyEditingTableCell,
    dropdownRef,
    locale,
    hotTableInstanceRef,
}) => {
    const addFormulaToCell = (formula: string) => {
        if (!formula) return;
        hotTableInstanceRef.current?.getMNEditor()?.setPlainTextContent(`=${formula}(`);
    };

    const [showFormulaDropdown, setShowFormulaDropdown] = useState(false);

    return (
        <>
            <FormulaDropdown
                ref={dropdownRef}
                addFormulaToCell={addFormulaToCell}
                showFormulaDropdown={showFormulaDropdown}
                setShowFormulaDropdown={setShowFormulaDropdown}
            />
            {isCurrentlyEditingTableCell && (
                <DatePickerContainer
                    showFormulaDropdown={showFormulaDropdown}
                    isCurrentlyEditingTableCell={isCurrentlyEditingTableCell}
                    gridSize={gridSize}
                    element={element}
                    locale={locale}
                    hotTableInstanceRef={hotTableInstanceRef}
                />
            )}
        </>
    );
};

export default TablePopups;
